export const SHOPWARE_CUSTOMER_GROUP_COOKIE = 'swCustomerGroup'
export const SHOPWARE_COOKIE_EXPIRE = 600